export const sanitizeLanguage: (locale: string) => string = (locale: string) => {
	if (locale.includes('-')) {
		return locale.split('-')[0];
	}
	return locale;
};
